module.exports = __webpack_public_path__ + "img/pl.6e10627c.svg";